// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decline[data-v-33678fa0]{position:relative;width:44px;height:44px;border-radius:50%;cursor:pointer}.decline-key[data-v-33678fa0]{--decline-color:#ff7875}.decline-key[data-v-33678fa0]:hover{--decline-color:#ff4d4f}.decline[data-v-33678fa0]:focus{outline:none;-webkit-box-shadow:0 0 0 2px var(--sui-blue-500);box-shadow:0 0 0 2px var(--sui-blue-500)}", ""]);
// Exports
module.exports = exports;
